export const host = window.location.href.includes(':8080') ? "http://localhost:8586" : "https://06designs.com";
// export const host = "https://06designs.com";
export const api = host + "/a1-api";

const makeCall = async (data = {}, commit) => {
  let headers = {};

  const auth = localStorage.getItem("access");
  if (auth) {
    headers["Authorization"] = "Bearer " + auth;
  }

  const callData = {
    method: data.method || "GET",
    headers
  };
  if (data.body) {
    if (data.requestType && data.requestType === 'form'){
      callData.body = data.body
    } else {
      callData.body = JSON.stringify(data.body)
      headers["Content-Type"] = "application/json"
    }
  }
  const useUrl = data.fullUrl ? host + data.fullUrl : api + data.url;
  let response = await fetch(useUrl, callData);

  if (response.status === 401 && !data.refresh) {
    const refreshToken = localStorage.getItem("refresh");
    const refresh = await makeCall({
      fullUrl: "/api/token/refresh/",
      refresh: true,
      method: "POST",
      body: { refresh: refreshToken }
    });
    if (refresh && refresh.access) {
      localStorage.setItem("access", refresh.access);
      callData.headers = {
        ...callData.headers,
        Authorization: "Bearer " + refresh.access
      }
      response = await fetch(useUrl, callData);
      const result = await response.json();
      return result;
    } else {
      commit('logOutUser')
    } // If refresh fails
  } else {
    const result = await response.json();
    return result;
  }
};

export default makeCall;
